import React, { useEffect } from "react";
import { MdPersonOutline } from "react-icons/md";
import { Rating } from "react-simple-star-rating";
import { Link, useNavigate } from "react-router-dom";
import { VscHeart, VscHeartFilled } from "react-icons/vsc";
import { RxDotFilled } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { favUnfav, cleanFavUnfav } from "../../redux/Slice/configSlice";
import { getAllCars } from "../../redux/Slice/carSlice";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

const CarCard = ({
  checkUncheckfav,
  data,
  image,
  carName,
  rating,
  seater,
  price,
  available,
}) => {
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const favUnFavStatus = useSelector((state) => state?.config?.favUnFavStatus);
  const favUnFavDetail = useSelector((state) => state?.config?.favUnFavDetail);
  const signInId = userDetail?.data?._id;
  // console.log("data", data);
  const favUnfavHandler = (carId, signInId) => {
    if (carId && signInId) {
      if (checkUncheckfav) {
        checkUncheckfav(carId);
      }
      dispatch(favUnfav({ carId: carId, signInId: signInId }));
    } else toast.error("Please sign in to add to favourite");
  };

  useEffect(() => {
    if (favUnFavStatus === "fulfilled" && favUnFavDetail?.success === true) {
      dispatch(cleanFavUnfav());
      // dispatch(getAllCars())
      // toast(favUnFavDetail?.message)
    }
  }, [favUnFavDetail]);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  const checkDetailsHandler=(id)=>{
    if(signInId)
      {
        const missingFields = [];
          if (!userDetail?.data?.image) missingFields.push("Profile photo");
          if (!userDetail?.data?.address) missingFields.push("Address");
          // if (!userDetail?.data?.drivingLicenseFront) missingFields.push("Driving license card front side");
          if (!userDetail?.data?.identityFront)
            missingFields.push("Identity card front side");
          if (!userDetail?.data?.identityBack)
            missingFields.push("Identity card back side");
          // if (!userDetail?.data?.drivingLicenseBack) missingFields.push("Identity card back side");
          if (missingFields.length > 0) {
            // Join missing fields into a message
            const missingFieldsMessage = missingFields.join(', ');
      
            // Show SweetAlert with a specific message for missing fields
            Swal.fire({
              title: 'Please complete your profile first!',
              text: `You need to complete the following fields: ${missingFieldsMessage}`,
              icon: 'warning',
              showCancelButton: false,
              confirmButtonText: 'OK',
              customClass:{
                confirmButton: 'btn img-btn',
              }
            }).then((result) => {
              if (result.isConfirmed) {
                navigate("/edit-profile")
                // Redirect the user to the profile page
                // history.push('/profile'); // or `navigate('/profile')` in React Router v6+
              }else{
                navigate("/edit-profile")
              }
            });
          }else{
            navigate(`/cardetail/${id}`)
          }
      }else{
        navigate("/login")
      }
      scrollToTop()
  }

  return (
    <div className="card card-shadow car-card border-0 h-100">
      <div className="box rounded-top mx-auto box_div position-relative">
        <img src={`${image}`} className="car-img" alt="Car Image" />
        <div className="heart-cls">
          {data?.isUserFavId?.includes(userDetail?.data?._id) ? (
            <VscHeartFilled
              className="heart-icon pointer"
              onClick={() => favUnfavHandler(data?._id, signInId)}
            />
          ) : (
            <VscHeart
              className="heart-icon pointer"
              onClick={() => favUnfavHandler(data?._id, signInId)}
            />
          )}

          {/* {(data?.isUserFavId === userDetail?.data?._id && data?.isFavorite) ? <VscHeartFilled className="heart-icon" onClick={() => favUnfavHandler(data?._id, signInId)} />
                            : <VscHeart className="heart-icon" onClick={() => favUnfavHandler(data?._id, signInId)} />} */}
        </div>
      </div>
      {/* <div className="card-body"> */}
      <div className={`card-body ${data?.withDriver ? "" : "mt_18"}`}>
        {data?.withDriver ? (
          <p className=" rounded-5 px-2 red-badge">
            <RxDotFilled className=" my-auto" />
            With Driver
          </p>
        ) : null}
        {/* {available ? <p className=' rounded-5 px-2 mb-2 green-badge' ><RxDotFilled className=' my-auto' />available</p>
                        :
                        <p className=' rounded-5 px-2 mb-2 red-badge' ><RxDotFilled className=' my-auto' />not available</p>
                    } */}
        <div className="d-flex flex-row justify-content-between align-items-center mb-2">
          <h5 className="card-title font secondaryColor text-capitalize card_title_font">
            {carName}-{data?.model?.carModel} (
            {data?.carCategoryId?.categoryName})
          </h5>
          <div>
            <p className="car-price m-0 font card_title_font">K{price}/Day</p>
          </div>
        </div>

        {/* <p className='secondaryColor seater' ><span >Max Power</span> : {data?.power} HP</p>
                    <p className='secondaryColor seater' ><span >Top Speed</span> : {data?.topSpeed} km/h</p>
                    <p className='secondaryColor seater' ><span >Motor</span> : {data?.motor}cc</p> */}
        <div className="secondaryColor seater  fs14 d-flex gap-2 align-items-center">
          <p className="m-0 min-width70">Max Power</p> <span>:</span>{" "}
          <span className="text-secondary"> {data?.power} HP</span>
        </div>
        <div className="secondaryColor seater  fs14 d-flex gap-2 align-items-center">
          <p className="m-0 min-width70">Top Speed</p> <span>:</span>{" "}
          <span className="text-secondary">{data?.topSpeed} km/h</span>
        </div>
        <div className="secondaryColor seater  fs14 d-flex gap-2 align-items-center">
          <p className="m-0 min-width70">Motor</p> <span>:</span>{" "}
          <span className="text-secondary">{data?.motor}cc</span>
        </div>
        <div className="align-items-center d-flex justify-content-between w-100 mt-1">
          <p className="secondaryColor seater">
            <MdPersonOutline className="seater-icon clr-theme fs-6 icon-user-m" />{" "}
            <span>{seater} seater</span>{" "}
          </p>
          <Rating
            iconsCount={5}
            fillColor="#f1a545"
            readonly={true}
            initialValue={rating}
            size="16px"
            allowFraction={true}
          />
        </div>

        <div className="mt-3">
          {/* <Link to='/cardetail/' onClick={scrollToTop} ><button type="button" className="btn img-btn primaryColor rounded-0">Rent now</button></Link> */}
          {/* <Link to={`/cardetail/${data?._id}`} onClick={scrollToTop}> */}
            <button type="button" className="btn w-100 img-btn primaryColor" onClick={()=>checkDetailsHandler(data?._id)}>
              Rent now
            </button>
          {/* </Link> */}
          {/* <Link to={loginDetail? '/rentyourcar' : '/login'} onClick={scrollToTop} ></Link> */}
        </div>
      </div>
    </div>
  );
};

export default CarCard;
